export default function scrollTop() {
	$(document).ready(function() {
		$("#video .video-controls button").click(function() {
			var video = $("#video video")[0];
			if (video.paused) {
				video.play();
				$(".video-controls button").removeClass("active");
				setTimeout(function() {
					$(".play").fadeToggle();
					$("#video .video-controls h5").fadeToggle();
				}, 200);
				$(".video-mascara").fadeToggle();
				setTimeout(function() {
					$(".pause").addClass("active");
				}, 1000);
			} else {
				video.pause();
				$(".video-controls button").removeClass("active");
				$(".play").fadeToggle();
				$("#video .video-controls h5").fadeToggle();
				$(".video-mascara").fadeToggle();
				$(".pause").removeClass("active");
			}
		});
	});

	// $(document).ready(function() {
	// 	// Função para obter o tamanho da tela
	// 	function getScreenSize() {
	// 		var width = $(window).width();
	// 		var height = $(window).height();
	// 		return { width: width, height: height };
	// 	}

	// 	// Exemplo de uso
	// 	var screenSize = getScreenSize();
	// 	console.log("Largura: " + screenSize.width);
	// 	console.log("Altura: " + screenSize.height);
	// });

	
	$(".history-video-title button").click(function() {
		var video = $("#history-video-content")[0];
		if (video.paused) {
			video.play();
				$(".history-video .pause").fadeIn();
		}
	});
	$(".history-video .pause").click(function() {
		var video = $("#history-video-content")[0];
		if (video.paused) {
		} else {
			video.pause();
			$(".history-video .pause").fadeOut(200);
			$(".history-video .play").fadeIn(6000);
		}
	});
	$(".history-video .play").click(function() {
		var video = $("#history-video-content")[0];
		if (video.paused) {
			console.log("teste")
			video.play();
				$(".history-video .play").fadeOut(100);
				$(".history-video .pause").fadeIn(6000);
		} else {
		}
	});
}
